const React = require("react");
//const auth = require("../../Authenticator.js");
//const server = require("../../Server.js");

const GeocodingImportForm = React.createClass({
    render() {
        return (<div>
            Address translation template file:&nbsp;
            <a href={this.props.SampleFileURL} target="_blank">Click here to download</a>
            <br /><br />
            To use: Add addresses to the template file (one per line), save the file, and upload it here. Once the file is processed, you will receive an email with the addresses in standard format, along with latitude and longitude information.
        </div>);
    }
});

module.exports = GeocodingImportForm;


// WEBPACK FOOTER //
// ./src/components/metadata/GeocodingImporterForm.jsx